<div class="pagination">
  <button type="button" *ngIf="from > 1" (click)="setPage(1)">1</button>
  <div class="dots" *ngIf="from > 2"></div>
  <button type="button" [class.active]="page === currentPage" (click)="setPage(page)" *ngFor="let page of pages">{{page}}</button>
  <div class="dots" *ngIf="to < total - 1"></div>
  <button type="button" *ngIf="to < total" (click)="setPage(total)">{{total}}</button>
  <button type="button" class="next" (click)="nextPage()" *ngIf="currentPage < total">Далее</button>
  <div class="count" *ngIf="data?.total">Показаны {{shownFrom}}–{{shownTo}} из {{data?.total}}</div>
</div>
